import _defineProperty from "/root/.jenkins/workspace/pro-fe-mobile/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @module:  route loading时 空页面
 * @author Liang Huang
 * @date 2020-11-10 10:48:51
 */
import React from 'react'; // import ContentLoader from 'react-content-loader';

import PropTypes from 'prop-types';
import './style';
import Header from '../../Header';
import LoadingComponent from '../../LoadingComponent';
import SkeletonBlog from '../Blog';
import SkeletonDetail from '../Detail';
import SkeletonList from '../List'; // interface IProps {
//   className?: string;
//   style?: React.CSSProperties;
//   hasHeader?: boolean;
// }

var listUrls = [/list/, /zhaopin\/delivery/, /zhaopin\/candidate/, /mytask/];
var blogUrls = [/zhaopin\/business/, /mresident\/home/];
var detailUrls = [/detail/]; // 根据url加载不同的skeleton组件

var renderByUrl = function renderByUrl(type) {
  var url = window.location.pathname;
  var details = detailUrls.filter(function (d) {
    return d.test(url);
  });
  var blogs = blogUrls.filter(function (d) {
    return d.test(url);
  });
  var lists = listUrls.filter(function (d) {
    return d.test(url);
  }); // console.log('details, url', details, detailUrls, url);

  if (details.length || type === 'detail') {
    return (
      /*#__PURE__*/
      React.createElement(SkeletonDetail, null)
    );
  } else if (blogs.length || type === 'blog') {
    return (
      /*#__PURE__*/
      React.createElement(SkeletonBlog, null)
    );
  } else if (lists.length || type === 'list') {
    return (
      /*#__PURE__*/
      React.createElement(SkeletonList, null)
    );
  }

  return (
    /*#__PURE__*/
    React.createElement(LoadingComponent, null)
  );
};

var SkeletonPage = function SkeletonPage(props) {
  var className = props.className,
      style = props.style,
      hasHeader = props.hasHeader,
      type = props.type; // console.log('SkeletonPage init');

  return (
    /*#__PURE__*/
    React.createElement("article", {
      className: "".concat(className, " SkeletonPage"),
      style: _objectSpread({}, style)
    }, hasHeader &&
    /*#__PURE__*/
    React.createElement(Header, {
      icon:
      /*#__PURE__*/
      React.createElement("span", null)
    }),
    /*#__PURE__*/
    React.createElement("div", {
      className: "SkeletonPage-content"
    }, renderByUrl(type)))
  );
};

SkeletonPage.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  hasHeader: PropTypes.bool,
  type: PropTypes.oneOf(['blog', 'detail', 'list'])
};
export default SkeletonPage;